export default __webpack_public_path__ + "static/media/smartWatch.7aec0acd.svg";